
export const weekcalculation =(data)=>{
    try{
        console.log(data,"data")
        let Startminus = data * 7 
        let currentDate =new Date(new Date().setDate(new Date().getDate() - Startminus))
        console.log(currentDate,"currentDate")
        var year = new Date(currentDate.getFullYear(), 0, 1)
        var days = Math.floor((currentDate - year) / (24 * 60 *60 * 1000));
        var week = Math.ceil(days / 7)
        var yr =currentDate.getFullYear()
        let val = week +"/"+ yr
        return val
    }catch(err){
        console.log(err,'weekcalculation_err')
    }
}

export const daysCalculation =(sec)=>{
  try{
    console.log(sec,"data")
    let min = Math.floor(sec / 60)
    let hrs = Math.floor(min / 60)
    let days = Math.floor(hrs/24)
    console.log(days,"days")
  }
  catch(err){
    console.log(err,'daysCalculation_err')
}

}